import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SolicitudAtestFitoViewModel, ParametrosNuevaSolicitudAtestFitoViewModel } from './datosbasicosAtestFito.types';

@Injectable()
export class SolicitudAtestFitoService {
    private paramsKey = 'atestFitoParams';
    public currentParamNuevaSolicitudAtestFito = new ParametrosNuevaSolicitudAtestFitoViewModel();
    public currentIdSolicitudAtestFito: number;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    // Persist params into localStorage or removes it if a NULL argument is given
    setParamsSolicitudAtestFito(params: ParametrosNuevaSolicitudAtestFitoViewModel | null): boolean {
        if (params) {
            localStorage.setItem(this.paramsKey, JSON.stringify(params));
        } else {
            localStorage.removeItem(this.paramsKey);
        }
        return true;
    }

    // Retrieves the params JSON object (or NULL if none)
    getParamsSolicitudAtestFito(): ParametrosNuevaSolicitudAtestFitoViewModel | null {
        let params: ParametrosNuevaSolicitudAtestFitoViewModel = new ParametrosNuevaSolicitudAtestFitoViewModel();
        let paramsJSON: ParametrosNuevaSolicitudAtestFitoViewModel;

        let i = localStorage.getItem(this.paramsKey);
        if (i) {
            paramsJSON = JSON.parse(i);

            params.IdTipoSolicitudAtestFito = paramsJSON.IdTipoSolicitudAtestFito;
            params.tipoSolicitudAtestFito = paramsJSON.tipoSolicitudAtestFito;
            params.IdCa = paramsJSON.IdCa;
            params.IdAc = paramsJSON.IdAc;
            params.IdProvincia = paramsJSON.IdProvincia;
            params.IdPaisDestino = paramsJSON.IdPaisDestino;

            return params;
        } else {
            return null;
        }
    }

    getSolicitudAtestFito(id: number): Observable<SolicitudAtestFitoViewModel> {
        return this.http.get<SolicitudAtestFitoViewModel>(this.baseUrl + 'api/exportacion/atestaciones/solicitudAtest/' + id).pipe();
    }

    getEnvioSolicitud(id: number): Observable<SolicitudAtestFitoViewModel> {
        return this.http.get<SolicitudAtestFitoViewModel>(this.baseUrl + 'api/exportacion/atestaciones/solicitudAtest/getenviosolicitudbyid/' + id).pipe();
    }

    /*--------*/

    createSolicitud(solicitudAtestFito: SolicitudAtestFitoViewModel): Observable<any> {
        return this.http.post<SolicitudAtestFitoViewModel>(this.baseUrl + 'api/exportacion/atestaciones/solicitudAtest', solicitudAtestFito).pipe();
    }

    editSolicitud(solicitudAtestFito: SolicitudAtestFitoViewModel): Observable<any> {
        return this.http.put<SolicitudAtestFitoViewModel>(this.baseUrl + 'api/exportacion/atestaciones/solicitudAtest', solicitudAtestFito).pipe();
    }
}
